import { axiosGet } from 'shared/api/axios'
import { apiUrls } from 'consts'
import ActionButtons from 'shared/components/ActionButtons'

interface getRowsProps {
  setDeleteEntryId: Function
  setShowModal: Function
  filter?: object
}

const getRows = async (props: getRowsProps) => {
  const getParams = {}

  //TODO getParams cannot be passed here when you remove data from the table
  const response = await axiosGet(apiUrls.permissions, getParams)

  const data = response.data

  data.forEach((row: any, index: number, dataArray: any) => {
    dataArray[index].action = (
      <ActionButtons
        buttons={[
          {
            type: 'u',
            url: '/edit-permission/' + row.id,
          },
          {
            type: 'd',
            id: dataArray[index].id,
            url: '/delete-permission/' + row.id,
            setDeleteEntryId: props.setDeleteEntryId,
            setShowModal: props.setShowModal,
          },
        ]}
      />
    )

    dataArray[index].active = dataArray[index].active === 1 ? 'Yes' : 'No'
  })

  return data
}

export default getRows
